import CaseFirstView from 'components/cases/common/CasesFirstView/'
import OverView from 'components/cases/common/Overview/'
import CaseStudy from 'components/home/CaseStudy'
import { firstViewItem, overviewTitle, overviewItem, issueSolutionItems } from './NttItems'
import FooterCTA from 'components/common/FooterCTA'

const Ntt = (): JSX.Element => {
  return (
    <section>
      <CaseFirstView firstViewItem={firstViewItem} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <FooterCTA />
      <CaseStudy enTitle="Case study" jaTitle="事例" tagType="h2" />
    </section>
  )
}

export default Ntt
